import { clipboard } from './clipboard';
import * as clipboardUtils from './utils';
export { clipboardUtils };
export const Clipboard = (builder, opts) => {
    builder.addPlugin((deps) => clipboard({
        yfmParser: deps.parser,
        textParser: deps.parserWithoutAttrs,
        serializer: deps.serializer,
        pasteFileHandler: opts.pasteFileHandler,
    }), builder.PluginPriority.VeryLow);
};
